<style>
	.fixHeader {
		position: fixed;
		right: 25px;
		top:50px;    
    	background-color: #353942!important;
    	z-index: 5;
	}
	#fix-header{
		height: 72px;
		padding-top: 20px;
    	border-bottom: 1px solid #292c33;
	}
	#fix-content{
		height: 72px;
	}
</style>
<template>
	<div id="fix-content" class="pr">
		<div class="panel-heading" id="fix-header" :class="isFix ? 'fixHeader' : ''" >
			<div class="row">
				<div class="col-xs-6 ptb4">
		            <span class="cae bk bk-green">{{title}}</span>
		        </div>
		        <div class="col-xs-6">
					<div class="btn-group pull-right pr15">
						<a class="btn btn-block btn-primary pull-right" @click="goback" v-if="noback!='no'"> 
							<i class="glyphicon glyphicon-chevron-left"></i>
							返回
						</a>
					</div>
					<div class="btn-group pull-right pr15" v-if="btn=='save'">
					      <button type="button" class="btn btn-primary" v-on:click="submit">
					      	<i class="glyphicon glyphicon-check"></i>
					      	保存并提交
					      </button>
				    </div>
				    <slot name="s1"></slot>
					<div class="btn-group pull-right pr15" v-if="btn=='edit'">
						<a href="javascript:;" class="btn btn-block btn-primary pull-right" @click="doUpdate"> 
							<i class="glyphicon glyphicon-pencil"></i>
							修改
						</a>
					</div>
					<slot name="s2"></slot>
					<slot name="s3"></slot>
				</div>	
			</div>	
		</div>
	</div>
</template>
<script>	
	module.exports = {
		props : ['title','rou','btn'],
		data : function(){
			return {
				isFix : false, //标识是否达到fix标准
			}
		},
		ready : function(){
			var self = this;
			var header = document.getElementById('fix-header');
			var style = 'width:' + header.clientWidth + 'px;height:' + header.clientHeight + 'px;';
			header.setAttribute('style',style);
			//滚动监听
			window.onscroll = function(){
				var t = document.documentElement.scrollTop || document.body.scrollTop;//滚动的距离
				if(t >= 70){
					self.isFix = true;
				}else{
					self.isFix = false;
				}
			};
		},
		methods : {
			submit : function(){
				this.$dispatch('submit');//分发传递
			},
			doUpdate: function(){
				this.$dispatch('doUpdate');//分发传递
			},
			goback: function(){
				this.$dispatch('goback');//分发传递
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Fixheader.vue?473daa32
 **/